import {RouteContext} from "../../RouteContext";
import {PlaceParticipationValueObject} from "../../../../model/vo/content/place/PlaceParticipationValueObject";
import {PlaceParticipationIO} from "../../../../io/content/place/PlaceParticipationIO";
import {ListPage} from "../../common/ListPage";
import {Column} from "../../common/Layout";
import {Text} from "@fluentui/react-components";
import React from "react";


export default function List(props: RouteContext) {
    return <>
        <Column gap={'16px'}>
            <ListPage
                {...props}
                description={PlaceParticipationValueObject.description}
                list={PlaceParticipationIO.list}
                count={PlaceParticipationIO.count}
                delete={PlaceParticipationIO.delete}
                postHref={'/admin/places/participations/post'}
                detailHref={item => `/admin/places/participations/${item.id}`}
                initialSearchConditions={[
                    {
                        name: 'deletedAt',
                        value: '',
                        condition: 'IsNull'
                    },
                ]}
                itemValue={(item, key) => {
                    if(key === 'answer' ){
                        return <Text>{item[key]?.slice(0, 20) || ''}</Text>
                    }
                    else {
                        return undefined
                    }
                }}
            />
        </Column>
    </>
}